enum AssetTagsConstants {
  CLEAR_TAG_ACTION_ERROR = '@AssetTags/CLEAR_ERROR_MODAL',

  GET_AVAILABLE_TAGS = '@AssetTags/GET_AVAILABLE_TAGS',
  GET_AVAILABLE_TAGS_REQUEST = '@AssetTags/GET_AVAILABLE_TAGS_REQUEST',
  GET_AVAILABLE_TAGS_REQUEST_SUCCESS = '@AssetTags/GET_AVAILABLE_TAGS_REQUEST_SUCCESS',
  GET_AVAILABLE_TAGS_REQUEST_ERROR = '@AssetTags/GET_AVAILABLE_TAGS_REQUEST_ERROR',

  CREATE_TAG_CATEGORY = '@AssetTags/CREATE_TAG_CATEGORY',
  CREATE_TAG_CATEGORY_REQUEST = '@AssetTags/CREATE_TAG_CATEGORY_REQUEST',
  CREATE_TAG_CATEGORY_REQUEST_SUCCESS = '@AssetTags/CREATE_TAG_CATEGORY_REQUEST_SUCCESS',
  CREATE_TAG_CATEGORY_REQUEST_ERROR = '@AssetTags/CREATE_TAG_CATEGORY_REQUEST_ERROR',

  UPDATE_TAG_CATEGORY = '@AssetTags/UPDATE_TAG_CATEGORY',
  UPDATE_TAG_CATEGORY_REQUEST = '@AssetTags/UPDATE_TAG_CATEGORY_REQUEST',
  UPDATE_TAG_CATEGORY_REQUEST_SUCCESS = '@AssetTags/UPDATE_TAG_CATEGORY_REQUEST_SUCCESS',
  UPDATE_TAG_CATEGORY_REQUEST_ERROR = '@AssetTags/UPDATE_TAG_CATEGORY_REQUEST_ERROR',

  DELETE_TAG_CATEGORY = '@AssetTags/DELETE_TAG_CATEGORY',
  DELETE_TAG_CATEGORY_REQUEST = '@AssetTags/DELETE_TAG_CATEGORY_REQUEST',
  DELETE_TAG_CATEGORY_REQUEST_SUCCESS = '@AssetTags/DELETE_TAG_CATEGORY_REQUEST_SUCCESS',
  DELETE_TAG_CATEGORY_REQUEST_ERROR = '@AssetTags/DELETE_TAG_CATEGORY_REQUEST_ERROR',

  CREATE_TAG = '@AssetTags/CREATE_TAG',
  CREATE_TAG_REQUEST = '@AssetTags/CREATE_TAG_REQUEST',
  CREATE_TAG_REQUEST_SUCCESS = '@AssetTags/CREATE_TAG_REQUEST_SUCCESS',
  CREATE_TAG_REQUEST_ERROR = '@AssetTags/CREATE_TAG_REQUEST_ERROR',

  UPDATE_TAG = '@AssetTags/UPDATE_TAG',
  UPDATE_TAG_REQUEST = '@AssetTags/UPDATE_TAG_REQUEST',
  UPDATE_TAG_REQUEST_SUCCESS = '@AssetTags/UPDATE_TAG_REQUEST_SUCCESS',
  UPDATE_TAG_REQUEST_ERROR = '@AssetTags/UPDATE_TAG_REQUEST_ERROR',

  DELETE_TAG = '@AssetTags/DELETE_TAG',
  DELETE_TAG_REQUEST = '@AssetTags/DELETE_TAG_REQUEST',
  DELETE_TAG_REQUEST_SUCCESS = '@AssetTags/DELETE_TAG_REQUEST_SUCCESS',
  DELETE_TAG_REQUEST_ERROR = '@AssetTags/DELETE_TAG_REQUEST_ERROR',
}
export default AssetTagsConstants;
